<div class="gate-block" ngbAutofocus>

  <div class="gate-block__banner">
    <i class="bi bi-exclamation-octagon-fill"></i>
    <div>
      <div class="gate-block__title">DO NOT ADMIT</div>
      <div class="gate-block__subtitle">This truck is flagged</div>
    </div>
  </div>

  <div class="gate-block__body">

    <div class="gate-block__plate">{{ registration }}</div>

    <div class="gate-block__facts">
      <div class="fact" *ngIf="block.flag.driver_name">
        <span class="k">Driver on file</span>
        <span class="v">{{ block.flag.driver_name }}</span>
      </div>
      <div class="fact" *ngIf="block.flag.transporter">
        <span class="k">Transporter</span>
        <span class="v">{{ block.flag.transporter }}</span>
      </div>
      <div class="fact" *ngIf="reference">
        <span class="k">Reference</span>
        <span class="v ref">{{ reference }}</span>
      </div>
    </div>

    <div class="gate-block__reason">
      <span class="k">Reason</span>
      <p>{{ block.flag.reason }}</p>
    </div>

    <!-- Operations have already ruled on this truck today. -->
    <div class="gate-block__declined" *ngIf="declined">
      <strong>Operations have already declined this truck.</strong>
      <p class="mb-0" *ngIf="declineRemark">{{ declineRemark }}</p>
    </div>

    <div class="gate-block__repeat" *ngIf="repeatAttempts > 1">
      This truck has now tried to enter <strong>{{ repeatAttempts }} times</strong>.
    </div>

    <div class="gate-block__action">
      <i class="bi bi-telephone-fill"></i>
      <span>CALL OPERATIONS</span>
    </div>

    <p class="gate-block__note">
      Operations have been notified automatically<span *ngIf="reference">, reference
      <strong>{{ reference }}</strong></span>. The check-in has <strong>not</strong> been created.
      If Operations approve this arrival, check the truck in again.
    </p>
  </div>

  <div class="gate-block__footer">
    <button type="button" class="btn btn-dark w-100" (click)="activeModal.close()">
      I understand — I have not admitted this truck
    </button>
  </div>
</div>
